import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import { useIntl } from "react-intl";
import clsx from "clsx";

import { IconComponent } from "@app/core";
import SettingsIcon from "@assets/icons/rounded/tune.svg";
import PlatformIcn from "@assets/icons/rounded/grid-view.svg";
import LogoutIcon from "@assets/icons/rounded/logout.svg";
import PersonIcon from "@assets/icons/rounded/person.svg";
import SyncIcon from "@assets/icons/rounded/sync.svg";
import useOutsideClick from "@app/util/outside-click";
import { ROUTES } from "@app/constants/routes";

import styles from "./nav-bar-settings-item-component.module.scss";

export interface INavBarSettingsItemProps {
  onLogout: () => void;
  role: string;
}

const NavBarSettingsItem = (props: INavBarSettingsItemProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const intl = useIntl();
  const dropdownRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  useOutsideClick([dropdownRef, buttonRef], () => {
    if (isOpen) {
      setIsOpen(false);
    }
  });

  const handleDropdownToggle = () => {
    setIsOpen(true);
  };

  return (
    <div className={styles.settings}>
      <button
        type="button"
        onClick={handleDropdownToggle}
        className={clsx(styles.settingsButton, isOpen && styles.active)}
        ref={buttonRef}
      >
        <IconComponent icon={SettingsIcon} size="20px" fillColor="white" />
      </button>
      <div className={styles.settingsDropdown} style={{ display: isOpen ? "initial" : "none" }}>
        <Link to={ROUTES.MY_ACCOUNT} className={styles.dropdownItem}>
          <IconComponent icon={PersonIcon} size="20px" fillColor="currentColor" />
          {intl.formatMessage({ id: "navbarSettingsItem.userAccount" })}
        </Link>
        {props.role === "admin" && (
          <Link to={ROUTES.PLATFORM_SETTINGS} className={styles.dropdownItem}>
            <IconComponent icon={PlatformIcn} size="20px" fillColor="currentColor" />
            {intl.formatMessage({ id: "navbarSettingsItem.platformSettings" })}
          </Link>
        )}
        {props.role === "admin" && (
          <Link to={ROUTES.CSS_SYNC} className={styles.dropdownItem}>
            <IconComponent icon={SyncIcon} size="20px" fillColor="currentColor" />
            {intl.formatMessage({ id: "navbarSettingsItem.cssSync" })}
          </Link>
        )}
        {props.role === "admin" && (
          <Link to={ROUTES.PRODUCT_PAGE_SYNC} className={styles.dropdownItem}>
            <IconComponent icon={SyncIcon} size="20px" fillColor="currentColor" />
            {intl.formatMessage({ id: "navbarSettingsItem.productPageSync" })}
          </Link>
        )}
        {props.role === "admin" && (
          <Link to={ROUTES.PRODUCT_DESCRIPTION} className={styles.dropdownItem}>
            <IconComponent icon={SyncIcon} size="20px" fillColor="currentColor" />
            {intl.formatMessage({ id: "navbarSettingsItem.productDescription" })}
          </Link>
        )}
        <a className={styles.dropdownItem} role="button" onClick={props.onLogout}>
          <IconComponent icon={LogoutIcon} size="20px" fillColor="currentColor" />
          {intl.formatMessage({ id: "navbarSettingsItem.logout" })}
        </a>
      </div>
    </div>
  );
};

export { NavBarSettingsItem };
